import type { LangCode } from "@/lib/gql/__generated__/graphql";
import { BillingTypeTarget, BillingTypeTerm } from "@/lib/gql/__generated__/graphql";

export const BillingTypeTermWithTargetI18n: {
	[key: BillingTypeTerm[number]]: {
		[key: BillingTypeTarget[number]]: {
			[key: LangCode[number]]: string;
		};
	};
} = {
	// 日ごと
	[BillingTypeTerm.PerDate]: {
		[BillingTypeTarget.Group]: {
			default: "日",
			en: "date",
		},
		[BillingTypeTarget.Person]: {
			default: "名・日",
			en: "person * date",
		},
		[BillingTypeTarget.Room]: {
			default: "部屋・日",
			en: "room * date",
		},
	},
	// 予約毎
	[BillingTypeTerm.PerReservation]: {
		[BillingTypeTarget.Group]: {
			default: "",
			en: "",
		},
		[BillingTypeTarget.Person]: {
			default: "名",
			en: "person",
		},
		[BillingTypeTarget.Room]: {
			default: "部屋",
			en: "room",
		},
	},
};
